<div class="content">
  <div class="table-container mat-elevation-z3">

    <table mat-table [dataSource]="items" matSort matSortActive="shopNumber" matSortDirection="asc" matSortDisableClear
      [matSortDirection]="sortDirection" [matSortActive]="sortColumn" (matSortChange)="onSortData($event)">

      <ng-container matColumnDef="brands">
        <th mat-header-cell *matHeaderCellDef> {{'common.brand' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <div class="brand">
            <img class="logo" [src]="brandService.getLogoById(element.brandId)" />
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="shopName">
        <th mat-header-cell *matHeaderCellDef> {{'common.shop-name' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.shopName}} </td>
      </ng-container>

      <ng-container matColumnDef="shopNumber">
        <th mat-header-cell *matHeaderCellDef> {{'common.shop-number' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.shopNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="printerIp">
        <th mat-header-cell *matHeaderCellDef> {{'administration.printers.ip-address' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{ element.printerIp }} </td>
      </ng-container>

      <ng-container matColumnDef="printerName">
        <th mat-header-cell *matHeaderCellDef> {{'reports.printers-status.printer-name' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.printerName}} </td>
      </ng-container>

      <ng-container matColumnDef="printerUniqueNumber">
        <th mat-header-cell *matHeaderCellDef> {{'common.printer-number' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.printerUniqueNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="printerEvidenceNumber">
        <th mat-header-cell *matHeaderCellDef> {{'administration.printers.evidence-number' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.printerEvidenceNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="receiptCount">
        <th mat-header-cell *matHeaderCellDef> {{'reports.printers-status.receipt-count' | translate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.receiptCount}} </td>
      </ng-container>

      <ng-container matColumnDef="dailyReportCount">
        <th mat-header-cell *matHeaderCellDef> {{'reports.printers-status.daily-report-count' |
          translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.dailyReportCount}} </td>
      </ng-container>

      <ng-container matColumnDef="dataFrom">
        <th mat-header-cell *matHeaderCellDef> {{'reports.printers-status.data-from' |
          translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.dataFrom | date:"yyyy-MM-dd"}}<br>{{element.dataFrom | date:"HH:mm"}} </td>
      </ng-container>

      <ng-container matColumnDef="dataTo">
        <th mat-header-cell *matHeaderCellDef> {{'reports.printers-status.data-to' |
          translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.dataTo | date:"yyyy-MM-dd"}}<br>{{element.dataTo | date:"HH:mm"}} </td>
      </ng-container>

      <ng-container matColumnDef="lastCommunicationDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'reports.printers-status.last-communication-date' |
          translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.lastCommunicationDate | date:"yyyy-MM-dd"}}<br>{{element.lastCommunicationDate | date:"HH:mm"}} </td>
      </ng-container>

      <ng-container matColumnDef="daysSinceLastCommunication">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="{{'reports.printers-status.days-since-last-communication' | translate}}">
          {{'reports.printers-status.last-communication-days' | translate}}</th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="element.daysSinceLastCommunication != null" class="rectangle"
            [ngStyle]="{'background-color': getRectangleColor(element.daysSinceLastCommunication, false)}">
            <b>{{element.daysSinceLastCommunication}}</b></div>
        </td>
      </ng-container>
      
      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.active' | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="element.isActive; then thenBlock else elseBlock"></div>
          <ng-template #thenBlock>
            <span class="icon-active">
              <fa-icon [icon]="faCheck" size="lg"></fa-icon>
            </span>
          </ng-template>
          <ng-template #elseBlock>
            <span class="icon-inactive">
              <fa-icon [icon]="faTimes" size="lg"></fa-icon>
            </span>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="printerMechanismStatus">
        <th mat-header-cell *matHeaderCellDef matTooltip="{{'reports.printers-status.printer-mechanism-status' | translate}}">
          {{'reports.printers-status.status' | translate}} </th>
        <td mat-cell *matCellDef="let element"
          matTooltip="{{'reports.printers-status.' + printerMechanismStatusEnum[element.printerMechanismStatus] | dashcase | translate}}">
          <div *ngIf="element?.printerMechanismStatus != null" class="rectangle"
            [ngStyle]="{'background-color': getRectangleColor(element.printerMechanismStatus, true)}">
            <b>{{ transformPrinterStatus('reports.printers-status.' +
              printerMechanismStatusEnum[element.printerMechanismStatus] | dashcase | translate) }}</b>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> {{'common.actions' | translate}} </th>
        <td mat-cell *matCellDef="let element;">
          <div class="row">
            <button mat-mini-fab color="primary"
              matTooltip="{{'reports.printers-status.check-printer-mechanism-status' | dashcase | translate}}"
              aria-label="Check printer mechanism status" (click)="checkPrinterMachanismStatus(element)">
              <fa-icon [icon]="faCheckPrinterMechanism"></fa-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container *ngFor="let column of columns" [matColumnDef]="column.filter.name">
        <th mat-header-cell *matHeaderCellDef="let element">
          <app-table-filter #filterRefs [column]="column" [filter]="filter" (filterChange)="filterData($event)"></app-table-filter>
        </th>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="filters"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

    <div class="empty-results" *ngIf="items.length === 0">{{'common.empty-results' | translate}}
    </div>

    <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageIndex]="pageIndex" color="primary"
      [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event; onPaginateChange($event)" showFirstLastButtons
      class="mat-paginator-row">
    </mat-paginator>

  </div>
</div>